import React, { useState, Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useLanguage } from '../utils/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar: React.FC = () => {
    const { t } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    
    const menuItems = [
        { href: '#introduction', label: t('nav.introduction') },
        { href: '#are-you-coming', label: t('nav.rsvp') },
        { href: '#where-should-we-go', label: t('nav.location') },
        { href: '#send-pic', label: t('nav.gallery') },
        { href: '#send-wish', label: t('nav.wishes') }
    ];

    const handleMenuClick = (href: string) => {
        setIsOpen(false);
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-brand">
                    <span className="navbar-title">Mark's 30th</span>
                </div>

                {/* Desktop Menu */}
                <div className="navbar-links-desktop">
                    {menuItems.map((item) => (
                        <button
                            key={item.href}
                            className="navbar-link"
                            onClick={() => handleMenuClick(item.href)}
                        >
                            {item.label}
                        </button>
                    ))}
                    <LanguageSwitcher />
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="mobile-menu-button md:hidden"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                        />
                    </svg>
                </button>

                {/* Mobile Menu */}
                <Transition
                    show={isOpen}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu as="div" className="mobile-menu md:hidden">
                        <div className="mobile-menu-items">
                            {menuItems.map((item) => (
                                <button
                                    key={item.href}
                                    className="mobile-menu-item"
                                    onClick={() => handleMenuClick(item.href)}
                                >
                                    {item.label}
                                </button>
                            ))}
                            <div className="px-4 py-2">
                                <LanguageSwitcher />
                            </div>
                        </div>
                    </Menu>
                </Transition>
            </div>
        </nav>
    );
};

export default Navbar;